var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34.0292C26.3888 34.0292 34 26.4176 34 17.0283C34 7.63891 26.3888 0.0273438 17 0.0273438C7.61116 0.0273438 0 7.63891 0 17.0283C0 26.4176 7.61116 34.0292 17 34.0292Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8447 5.31641V10.5258L19.1369 17.0281L12.8447 23.5304V28.7399L24.1781 17.0281L12.8447 5.31641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.6ed97182a57a2ee83f55c2d630f68a64.svg";
export { ForwardRef as ReactComponent };